import React, { useState, useEffect } from "react";
import Header from "../../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import Switch from "../../ShareElements/TextInput/Switch";
import DesktopOnlyOverlay from "../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import UnsavedChangesAlert from "../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../Config";
import Select from "../../ShareElements/Select/Select";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import IdentityField from "./Components/IdentityField";
import { NavLink } from "react-router-dom";

const AddUser = (props) => {
  const [Profiles, setProfiles] = useState([]);
  const [InitialProfiles, setInitialProfiles] = useState([]);
  const [MaxProfileCount, setMaxProfileCount] = useState();
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [HasUnsaveChanges, setHasUnsavedChanges] = useState(false);
  const [AddedItemsList, setAddedItemsList] = useState([]);
  const [DataIsLoaded, setDataIsLoaded] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [HasValidationError, setHasErrors] = useState(false); // to check if there is validation error
  const [ToastIsShown, setToastIsShown] = useState(false);
  const [UserCreated, setUserCreated] = useState(false);
  const [CreatedUserIdentity, setCreatedUserIdentity] = useState();
  const [CreatedUser, setCreatedUser] = useState({});

  useEffect(() => {
    getProfilesList();
    //global variable for storing validation status during user creation
    window.localStorage.setItem("HasUMvalidationError", 0); // 0:false, 1:true
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const getProfilesList = () => {
    var Data = JSON.stringify({
      size: 1000,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });
    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProfiles(Res.data.results);
        setInitialProfiles(Res.data.results);
        setMaxProfileCount(parseInt(Res.data.results.length));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setHasUnsavedChanges(true);
    } else {
      document.getElementById("back").click();
    }
  };
  const close = () => {
    setHasUnsavedChanges(false);
  };
  const saveAndLeave = () => {
    close();
    var HasErrors;
    let EmailRegEx = /\S+@\S+\.\S+/; //Email Regular expression
    let Username = document.getElementById("username").value;
    let ProfilesLength = AddedItemsList.length + 1;
    for (let i = 0; i < ProfilesLength; i++) {
      var ProfileId = document.getElementById(
        "select-profile-" + i + "-filter"
      ).value;
      if (ProfileId.length === 0) {
        showEmptyProfileName(i);
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
      }
    }
    if (Username.length === 0 || !Username.match(EmailRegEx)) {
      if (Username.length === 0) {
        showUsernameValidationError("Please enter the username.");
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
      } else if (!Username.match(EmailRegEx)) {
        showUsernameValidationError("Please enter a valid email address.");
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
      }
    } else {
      initiateUserCreation();
    }
    setTimeout(() => {
      if (window.localStorage.getItem("HasUMvalidationError") === "0") {
        document.getElementById("back").click();
      }
    }, 1500);
  };
  const discard = () => {
    setHasUnsavedChanges(false);
    document.getElementById("back").click();
  };
  const addProfile = () => {
    if (MaxProfileCount <= parseInt(AddedItemsList.length + 1)) {
      setToastIsShown(true);
      setTimeout(() => {
        setToastIsShown(false);
      }, 4000);
    } else {
      enableSave();
      let NewList = AddedItemsList;
      NewList.push({});
      setAddedItemsList(NewList);
      setDataIsLoaded(!DataIsLoaded);
    }
  };
  const deletePermission = (i) => {
    console.log(i);
    let DeselectedProfile = {
      id: document.getElementById(
        "select-profile-" + parseInt(i + 1) + "-filter"
      ).value,
      name: document.getElementById(
        "pre-selected-select-profile-" + parseInt(i + 1)
      ).innerHTML,
    };
    setMaxProfileCount(MaxProfileCount + 1);
    if (DeselectedProfile.id.length > 0) {
      Profiles.push(DeselectedProfile);
    }
    document.getElementById("added-row-" + parseInt(i + 1)).remove();
    enableSave();
  };
  const validateEntries = () => {
    let EmailRegEx = /\S+@\S+\.\S+/; //Email Regular expression
    let Username = document.getElementById("identity").value;
    let ProfilesLength = AddedItemsList.length + 1;
    let EmptyIds = [];

    if (
      document.getElementById("is-superadmin-switch-holder") !== null &&
      document.getElementById("is-superadmin-switch-holder").classList
        .length === 2
    ) {
      for (let i = 0; i < ProfilesLength; i++) {
        var ProfileId = document.getElementById(
          "select-profile-" + i + "-filter"
        ).value;
        if (ProfileId.length === 0) {
          showEmptyProfileName(i);
          EmptyIds.push(i);
        }
      }
    }

    if (
      document.getElementById("is-superadmin-switch-holder") !== null &&
      document
        .getElementById("is-superadmin-switch-holder")
        .classList.contains("off")
    ) {
      if (Username.length === 0 || EmptyIds.length > 0) {
        validateUsername(Username);
      } else {
        if (!UserCreated) {
          initiateUserCreation();
        } else {
          editUser();
        }
      }
    } else {
      if (Username.length === 0) {
        validateUsername(Username);
      } else {
        if (!UserCreated) {
          initiateUserCreation();
        } else {
          editUser();
        }
      }
    }
  };
  const validateUsername = (Username) => {
    if (Username.length === 0) {
      showUsernameValidationError("Please enter the username.");
    } else {
      return null;
    }
  };
  const validateEmailFormat = (Email, EmailRegEx) => {
    if (Email.length > 0 && !Email.match(EmailRegEx)) {
      showUsernameValidationError("Please enter a valid email address.");
    } else {
      return null;
    }
  };
  const initiateUserCreation = () => {
    if (!HasValidationError) {
      setIsLoading(true);
      fetchEmployeeByEmail();
    }
  };
  const fetchEmployeeByEmail = () => {
    let Email = document.getElementById("username").value;
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/employee/" + Email,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createUser(Res.data.id);
        setCreatedUserIdentity(Res.data.firstName + " " + Res.data.lastName);
        setCreatedUser(Res.data);
      })
      .catch((Err) => {
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
        console.log(Err);
        setIsLoading(false);
        if (Err.response !== undefined && Err.response.status === 404) {
          showUsernameValidationError(Err.response.data.messages + ".");
          assignRolesToUser();
        }
      });
  };
  const createUser = (EmployeeId) => {
    let User = {
      employeeId: EmployeeId,
    };
    if (document.getElementById("locked-switch-holder").classList.length > 1) {
      User.accountNonLocked = true;
    } else {
      User.accountNonLocked = false;
    }

    if (document.getElementById("active-switch-holder").classList.length > 1) {
      User.enabled = false;
    } else {
      User.enabled = true;
    }

    if (
      document.getElementById("is-superadmin-switch-holder") === null ||
      document.getElementById("is-superadmin-switch-holder").classList
        .length === 2
    ) {
      User.superAdmin = false;
    } else {
      User.superAdmin = true;
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: User,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        assignRolesToUser(Res.data.id);
        setUserCreated(true);
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 409) {
          showUsernameValidationError(Err.response.data.messages[0]);
        }
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
        setIsLoading(false);
        enableSave();
      });
  };
  const assignRolesToUser = (UserId) => {
    let ProfilesLength = AddedItemsList.length + 1;
    let RolesToAssign = [];
    for (let i = 0; i < ProfilesLength; i++) {
      RolesToAssign.push(
        document.getElementById("select-profile-" + i + "-filter").value
      );
    }
    let Data = {
      rolesId: RolesToAssign,
      userId: UserId,
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assignment/role-to-user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsLoading(false);
        disableSaveBtn();
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
        window.localStorage.setItem("HasUMvalidationError", 1); //0:false 1:true
      });
  };
  const showEmptyProfileName = (i) => {
    document
      .getElementById("select-profile-" + i + "-select")
      .classList.add("cx-select-error-shown");
  };
  const showUsernameValidationError = (ErroMessage) => {
    document.getElementById("validation-error").innerHTML = ErroMessage;
    document.getElementById("validation-error").style.display = "block";
    document.getElementById("identity").classList.add("wrong");
    if (document.getElementById("identity-info") !== null) {
      document.getElementById("identity-info").style.display = "none";
    }
  };
  const removeUserNameError = () => {
    document.getElementById("validation-error").innerHTML = "";
    document.getElementById("validation-error").style.display = "none";
    document.getElementById("identity").classList.remove("wrong");
    if (document.getElementById("identity-info") !== null) {
      document.getElementById("identity-info").style.display = "block";
    }
  };
  const updateRemainingProfiles = (i) => {
    enableSave();
    // removing the currently selected profile from the list
    let ChosenProfile = document.getElementById(
      "select-profile-" + i + "-filter"
    ).value;
    let ProfileIds = [];
    Profiles.map((Profile) => {
      ProfileIds.push(Profile.id);
    });
    Profiles.splice(ProfileIds.indexOf(ChosenProfile), 1);

    // adding the unselected profile to the dropdown options
    if (
      document.getElementById("select-profile-" + i + "-previous-name").value
        .length > 0
    ) {
      Profiles.push({
        id: document.getElementById("select-profile-" + i + "-previous-value")
          .value,
        name: document.getElementById("select-profile-" + i + "-previous-name")
          .value,
      });
    }
  };

  const handleSuperAdminStatus = () => {
    enableSave();
    if (
      !document
        .getElementById("is-superadmin-switch-holder")
        .classList.contains("off")
    ) {
      if (AddedItemsList.length === 0) {
        document.getElementById("added-row-0").classList.add("disabled");
        document.getElementById("add-btn").classList.add("disabled-add");
      } else {
        for (let i = 0; i <= AddedItemsList.length; i++) {
          if (document.getElementById("added-row-" + i) !== null) {
            document.getElementById("added-row-" + i).classList.add("disabled");
          }
        }
        document.getElementById("add-btn").classList.add("disabled-add");
      }
    } else {
      if (AddedItemsList.length === 0) {
        document.getElementById("added-row-0").classList.remove("disabled");
        document.getElementById("add-btn").classList.remove("disabled-add");
      } else {
        for (let i = 0; i <= AddedItemsList.length; i++) {
          if (document.getElementById("added-row-" + i) !== null) {
            document
              .getElementById("added-row-" + i)
              .classList.remove("disabled");
          }
        }
        document.getElementById("add-btn").classList.remove("disabled-add");
      }
    }
  };

  const editUser = () => {
    let User = {
      id: CreatedUser.id,
      email: document.getElementById("username").value,
    };
    if (document.getElementById("locked-switch-holder").classList.length > 1) {
      User.accountNonLocked = true;
    } else {
      User.accountNonLocked = false;
    }
    if (document.getElementById("active-switch-holder").classList.length > 1) {
      User.enabled = false;
    } else {
      User.enabled = true;
    }
    if (
      document.getElementById("is-superadmin-switch-holder") === null ||
      document.getElementById("is-superadmin-switch-holder").classList
        .length === 2
    ) {
      User.superAdmin = false;
    } else {
      User.superAdmin = true;
    }
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: User,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        assignRolesToUser(Res.data.id);
      })
      .catch((Err) => {
        console.log(Err.response);
        setHasUnsavedChanges(false);
        enableSave();
        if (Err.response !== undefined && Err.response.status === 403) {
          showUsernameValidationError("You are not allowed to edit this user.");
        }
        setIsLoading(false);
      });
  };

  return (
    <div className="main-content security-settings">
      <NavLink to="../" id="back" className="hidden"></NavLink>
      <DesktopOnlyOverlay LangData={props.LangData} />
      {HasUnsaveChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
        />
      ) : null}
      <Header PageName={translateText("user_management")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("security_settings")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("user_management")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("add_user")}</p>
        </div>
      </div>
      <div className="user-management-form">
        <section className="form-header">
          <button
            className="return"
            id="return"
            onClick={() => cancelOperation()}
          >
            <i className="feather-arrow-left"></i>
          </button>
          <p>{translateText("new_user")}</p>
          <div className="button-group">
            <button onClick={() => cancelOperation()} className="back">
              {translateText("cancel")}
            </button>
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("personal_information")}</h1>
          </div>
          <div className="form-field bottom-margined">
            <p className="form-item-label">
              {translateText("identity")}{" "}
              <p className="required less-spaced">*</p>
            </p>
            {UserCreated ? (
              <input
                type="text"
                id="identity"
                placeholder=""
                value={CreatedUserIdentity}
                disabled={true}
                className="disabled-text-input"
              />
            ) : (
              <IdentityField
                NamePlaceholder={
                  translateText("identity_field_name_placeholder") + ", "
                }
                PosPlaceholder={
                  translateText("identity_field_pos_title_placeholder") + ", "
                }
                CountryPlaceholder={translateText("country")}
                EnableSave={() => enableSave()}
                RemoveError={() => removeUserNameError()}
                LangData={props.LangData}
              />
            )}
            <p id="validation-error"></p>
          </div>
          <div className="form-field">
            <p className="form-item-label">
              {translateText("username")} <p className="required">*</p>
            </p>
            <input
              type="text"
              id="username"
              placeholder=""
              disabled={true}
              className="disabled-text-input"
            />
          </div>
          <div className="form-field">
            <p className="disabled-text form-item-label">
              {translateText("ad_credentials")}
            </p>
            <input
              type="text"
              id="AD-cred"
              disabled={true}
              placeholder=""
              className="disabled-text-input"
            />
          </div>
          <div className="form-field">
            <p className="form-item-label disabled-text">LDAP</p>
            <input
              type="text"
              id="LDAP"
              disabled={true}
              placeholder=""
              className="disabled-text-input"
            />
          </div>
          <div className="section-separator"></div>
          <div className="form-head">
            <h1>{translateText("user_settings")}</h1>
          </div>
          <div className="form-field">
            <p className="form-item-label">{translateText("activation")}</p>
            <Switch
              Id="active"
              IsActive={true}
              ChangeEvent={() => enableSave()}
            />
          </div>
          {window.localStorage.getItem("IsSuperAdmin") === "1" ? (
            <div className="form-field">
              <p className="form-item-label">{translateText("lock_account")}</p>
              <Switch
                Id="locked"
                IsActive={false}
                ChangeEvent={() => enableSave()}
                IsDisabled
              />
            </div>
          ) : (
            <div className="form-field">
              <p className="form-item-label">{translateText("lock_account")}</p>
              <Switch
                Id="locked"
                IsActive={false}
                ChangeEvent={() => enableSave()}
                IsDisabled
              />
            </div>
          )}
          <div className="form-field">
            <p className="form-item-label">
              {translateText("wizard_completed")}
            </p>
            <Switch
              Id="wizard"
              IsActive={false}
              ChangeEvent={() => null}
              IsDisabled
            />
          </div>
          {window.localStorage.getItem("IsSuperAdmin") === "1" ? (
            <div className="form-field">
              <p className="form-item-label">Superadmin</p>
              <Switch
                Id="is-superadmin"
                IsActive={false}
                ChangeEvent={() => handleSuperAdminStatus()}
              />
            </div>
          ) : null}
          <div className="form-field">
            <p className="section-label">
              {translateText("assigned_profile")} <p className="required">*</p>
            </p>
            <section className="profiles-assigned">
              <div className="list">
                <div className="added-item" id="added-row-0">
                  <Select
                    Initial={translateText("select_profiles")}
                    Options={Profiles}
                    IsWithId
                    NoSelectStyles={true}
                    Id={"select-profile-" + 0}
                    ChangeHandler={() => updateRemainingProfiles(0)}
                    ValidationError="Please specify the scope."
                  />
                </div>
                {AddedItemsList.length === 0 ? null : (
                  <React.Fragment>
                    {AddedItemsList.map((Item, i) => (
                      <div
                        className="added-item"
                        id={"added-row-" + parseInt(i + 1)}
                      >
                        <Select
                          Initial={translateText("select_profiles")}
                          Options={Profiles}
                          IsWithId
                          NoSelectStyles={true}
                          Id={"select-profile-" + parseInt(i + 1)}
                          PreSelected={false}
                          ChangeHandler={() =>
                            updateRemainingProfiles(parseInt(i + 1))
                          }
                          ValidationError="Please specify the scope."
                        />
                        <button
                          onClick={() => deletePermission(parseInt(i))}
                          className="remove-btn"
                        >
                          <i className="feather-x"></i>
                        </button>
                      </div>
                    ))}
                  </React.Fragment>
                )}
              </div>
              <div className="add" id="add-btn">
                <button onClick={() => addProfile()} className="add-to-list">
                  <i className="feather-plus"></i>
                  {translateText("add")}
                </button>
              </div>
            </section>
          </div>
        </section>
      </div>
      {ToastIsShown ? (
        <div className="snackbar">
          <p>All available profiles have been added.</p>
          <button onClick={() => setToastIsShown(false)}>DISMISS</button>
        </div>
      ) : null}
    </div>
  );
};
export default AddUser;
